import { IComponentOptions } from "angular";
import { MachineConfigurationTypeDetailViewComponentController } from "./controller";

export const vsComponentName = "machineConfigurationTypeDetailViewComponent";

export const MachineConfigurationTypeDetailViewComponentOptions: IComponentOptions =
  {
    controller: MachineConfigurationTypeDetailViewComponentController,
    controllerAs: "machineConfigurationTypeDetailViewComponentController",
    template: require("!html-loader!./index.html").default,
    bindings: {
      machineConfigurationType: "<",
      showInfoSref: "<",
    },
  };
